import React, { useEffect, useState, useCallback } from 'react';
import { toast } from 'react-toastify';
import { useAuth } from '../../context/AuthContext';
import { getApiErrorMessage } from '../../services/apiError';
import {
  getDerasarNotificationSettings,
  updateDerasarNotificationSetting,
} from '../../services/api';
import NotificationSettingsTable from '../../components/notifications/NotificationSettingsTable';
import styles from './DerasarNotificationSettings.module.css';

const DerasarNotificationSettings = () => {
  const { activeDerasarId } = useAuth();
  const [events, setEvents] = useState([]);
  const [channels, setChannels] = useState({ emailEnabled: true, whatsappEnabled: true });
  const [loading, setLoading] = useState(true);

  const load = useCallback(async () => {
    if (!activeDerasarId) return;
    setLoading(true);
    try {
      const data = await getDerasarNotificationSettings(activeDerasarId);
      setEvents(data.events);
      if (data.channels) setChannels(data.channels);
    } catch (err) {
      toast.error(getApiErrorMessage(err, 'Failed to load notification settings'));
    } finally {
      setLoading(false);
    }
  }, [activeDerasarId]);

  useEffect(() => { load(); }, [load]);

  const persist = async (eventKey, patch) => {
    const prev = events;
    setEvents((list) => list.map((e) => (e.key === eventKey ? { ...e, ...patch } : e)));
    try {
      await updateDerasarNotificationSetting({ derasarId: activeDerasarId, eventKey, ...patch });
    } catch (err) {
      setEvents(prev);
      toast.error(getApiErrorMessage(err, 'Failed to update setting'));
    }
  };

  const onToggle = (eventKey, channel, value) =>
    persist(eventKey, channel === 'email' ? { emailEnabled: value } : { whatsappEnabled: value });

  const onCadenceChange = (eventKey, value) => persist(eventKey, { reminderCadence: value });

  if (loading) return <div className={styles.loading}>Loading…</div>;

  return (
    <div>
      <div className="page-header">
        <h2>Notification Settings</h2>
        <p className={styles.subtitle}>
          Notifications your members receive over Email &amp; WhatsApp. In-app is always on;
          a greyed-out column is turned off by the platform admin.
        </p>
      </div>
      <div className="card">
        <div className="table-container">
          <NotificationSettingsTable
            events={events}
            onToggle={onToggle}
            onCadenceChange={onCadenceChange}
            channelDisabled={{ email: !channels.emailEnabled, whatsapp: !channels.whatsappEnabled }}
            showCadence
          />
        </div>
      </div>
    </div>
  );
};

export default DerasarNotificationSettings;
